// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Js_array = require("rescript/lib/js/js_array.js");
var ExpiryInfo = require("./ExpiryInfo.bs.js");
var AreaSummary = require("../graphql/AreaSummary.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var GraphQLConverter = require("../../common/GraphQLConverter.bs.js");
var Types__Clients__Contact = require("./Types__Clients__Contact.bs.js");

function defaultToFalse(__x) {
  return Belt_Option.getWithDefault(__x, false);
}

function defaultToTrue(__x) {
  return Belt_Option.getWithDefault(__x, true);
}

function decodeOptionalUTCDate(x) {
  return GraphQLConverter.Helpers.decodeOption(GraphQLConverter.Helpers.parseUTCDateFromFloat, x);
}

function decodeOptionalCalendarDate(x) {
  return GraphQLConverter.Helpers.decodeOption(GraphQLConverter.Helpers.decodeCalendarDate, x);
}

function decode(obj) {
  var partial_arg = GraphQLConverter.Helpers.some(obj.maxPrice)("maxPrice was None");
  var partial_arg$1 = GraphQLConverter.Helpers.some(obj.minPrice)("minPrice was None");
  var partial_arg$2 = function (param) {
    return GraphQLConverter.Helpers.flatMap((function (param) {
                  return GraphQLConverter.Helpers.source(obj, param);
                }), partial_arg$1, param);
  };
  return GraphQLConverter.Helpers.run(function (min, max) {
                return {
                        NAME: "Monthly",
                        VAL: {
                          NAME: "PriceRange",
                          VAL: [
                            min,
                            max
                          ]
                        }
                      };
              })(function (param) {
              return GraphQLConverter.Helpers.flatMap(partial_arg$2, partial_arg, param);
            });
}

var ppx_printed_query = "fragment RentalNeedPriceRange on RentalNeed   {\nminPrice  \nmaxPrice  \n}\n";

function parse(value) {
  var value$1 = Js_json.decodeObject(value);
  var tmp;
  if (value$1 !== undefined) {
    var value$2 = Caml_option.valFromOption(value$1);
    var value$3 = Js_dict.get(value$2, "minPrice");
    var field_minPrice;
    if (value$3 !== undefined) {
      var value$4 = Caml_option.valFromOption(value$3);
      field_minPrice = (value$4 == null) ? undefined : value$4;
    } else {
      field_minPrice = undefined;
    }
    var value$5 = Js_dict.get(value$2, "maxPrice");
    var field_maxPrice;
    if (value$5 !== undefined) {
      var value$6 = Caml_option.valFromOption(value$5);
      field_maxPrice = (value$6 == null) ? undefined : value$6;
    } else {
      field_maxPrice = undefined;
    }
    tmp = {
      minPrice: field_minPrice,
      maxPrice: field_maxPrice
    };
  } else {
    tmp = Js_exn.raiseError("Unexpected GraphQL query response");
  }
  return decode(tmp);
}

var name = "RentalNeedPriceRange";

function ret_type(f) {
  return {};
}

var MT_Ret = {};

var RentalNeedPriceRange = {
  ppx_printed_query: ppx_printed_query,
  query: ppx_printed_query,
  parse: parse,
  name: name,
  ret_type: ret_type,
  MT_Ret: MT_Ret
};

var PriceRange = {
  decode: decode,
  RentalNeedPriceRange: RentalNeedPriceRange,
  Fragment: undefined
};

function propertyTypesDecoder(param) {
  return GraphQLConverter.Helpers.decodeRequired("propertyTypes (array) was None", (function (param) {
                return GraphQLConverter.Helpers.decodeArray((function (param) {
                              return GraphQLConverter.Helpers.decodeRequired("propertyType (member) was None", (function (x) {
                                            return {
                                                    TAG: /* Ok */0,
                                                    _0: x
                                                  };
                                          }), param);
                            }), param);
              }), param);
}

function decode$1(obj) {
  var partial_arg = GraphQLConverter.Helpers.ok(obj.rentalNeedPropertyTypes);
  return GraphQLConverter.Helpers.run(function (i) {
                return i;
              })(function (param) {
              return GraphQLConverter.Helpers.flatMap((function (param) {
                            return GraphQLConverter.Helpers.source(obj, param);
                          }), partial_arg, param);
            });
}

var ppx_printed_query$1 = "fragment rentalNeedPropertyTypes on RentalNeed   {\nrentalNeedPropertyTypes: propertyTypes  \n}\n";

function parse$1(value) {
  var value$1 = Js_json.decodeObject(value);
  var tmp;
  if (value$1 !== undefined) {
    var value$2 = Js_dict.get(Caml_option.valFromOption(value$1), "rentalNeedPropertyTypes");
    var field_rentalNeedPropertyTypes;
    if (value$2 !== undefined) {
      var value$3 = Caml_option.valFromOption(value$2);
      field_rentalNeedPropertyTypes = propertyTypesDecoder(!(value$3 == null) ? Js_array.map((function (value) {
                    if (value == null) {
                      return ;
                    }
                    var tmp = value === "SINGLE_FAMILY" ? "SINGLE_FAMILY" : "CONDO";
                    return tmp;
                  }), value$3) : undefined);
    } else {
      field_rentalNeedPropertyTypes = Js_exn.raiseError("Unexpected GraphQL query response");
    }
    tmp = {
      rentalNeedPropertyTypes: field_rentalNeedPropertyTypes
    };
  } else {
    tmp = Js_exn.raiseError("Unexpected GraphQL query response");
  }
  return decode$1(tmp);
}

var name$1 = "rentalNeedPropertyTypes";

function ret_type$1(f) {
  return {};
}

var MT_Ret$1 = {};

var RentalNeedPropertyTypes = {
  ppx_printed_query: ppx_printed_query$1,
  query: ppx_printed_query$1,
  parse: parse$1,
  name: name$1,
  ret_type: ret_type$1,
  MT_Ret: MT_Ret$1
};

var PropertyTypes = {
  propertyTypesDecoder: propertyTypesDecoder,
  decode: decode$1,
  RentalNeedPropertyTypes: RentalNeedPropertyTypes,
  Fragment: undefined
};

function decode$2(obj) {
  var partial_arg = GraphQLConverter.Helpers.ok(obj.availableFrom);
  var partial_arg$1 = GraphQLConverter.Helpers.some(obj.leaseLength)("leaseLength was None");
  var partial_arg$2 = function (param) {
    return GraphQLConverter.Helpers.flatMap((function (param) {
                  return GraphQLConverter.Helpers.source(obj, param);
                }), partial_arg$1, param);
  };
  return GraphQLConverter.Helpers.run(function (length, availableFrom) {
                return {
                        length: length,
                        availableFrom: availableFrom
                      };
              })(function (param) {
              return GraphQLConverter.Helpers.flatMap(partial_arg$2, partial_arg, param);
            });
}

var ppx_printed_query$2 = "fragment rentalNeedLease on RentalNeed   {\navailableFrom: availableFromV2  \nleaseLength  \n}\n";

function parse$2(value) {
  var value$1 = Js_json.decodeObject(value);
  var tmp;
  if (value$1 !== undefined) {
    var value$2 = Caml_option.valFromOption(value$1);
    var value$3 = Js_dict.get(value$2, "availableFrom");
    var field_availableFrom;
    if (value$3 !== undefined) {
      var value$4 = Caml_option.valFromOption(value$3);
      field_availableFrom = decodeOptionalCalendarDate(!(value$4 == null) ? Caml_option.some(value$4) : undefined);
    } else {
      field_availableFrom = Js_exn.raiseError("Unexpected GraphQL query response");
    }
    var value$5 = Js_dict.get(value$2, "leaseLength");
    var field_leaseLength;
    if (value$5 !== undefined) {
      var value$6 = Caml_option.valFromOption(value$5);
      if (value$6 == null) {
        field_leaseLength = undefined;
      } else {
        var tmp$1;
        switch (value$6) {
          case "LONG" :
              tmp$1 = "LONG";
              break;
          case "SHORT" :
              tmp$1 = "SHORT";
              break;
          default:
            tmp$1 = "SHORT_OR_LONG";
        }
        field_leaseLength = tmp$1;
      }
    } else {
      field_leaseLength = undefined;
    }
    tmp = {
      leaseLength: field_leaseLength,
      availableFrom: field_availableFrom
    };
  } else {
    tmp = Js_exn.raiseError("Unexpected GraphQL query response");
  }
  return decode$2(tmp);
}

var name$2 = "rentalNeedLease";

function ret_type$2(f) {
  return {};
}

var MT_Ret$2 = {};

var RentalNeedLease = {
  ppx_printed_query: ppx_printed_query$2,
  query: ppx_printed_query$2,
  parse: parse$2,
  name: name$2,
  ret_type: ret_type$2,
  MT_Ret: MT_Ret$2
};

var Lease = {
  decode: decode$2,
  RentalNeedLease: RentalNeedLease,
  Fragment: undefined
};

function make(status, expiryInfo) {
  var aboutToExpire = ExpiryInfo.aboutToExpire(expiryInfo);
  if (status === "WITHDRAWN") {
    return /* Withdrawn */1;
  } else if (status === "REMOVED") {
    return /* Removed */4;
  } else if (status === "EXPIRED") {
    return /* Expired */3;
  } else if (status === "RENTED") {
    return /* Rented */2;
  } else if (aboutToExpire) {
    return /* Expiring */{
            _0: ExpiryInfo.daysToExpiration(expiryInfo)
          };
  } else {
    return /* Active */0;
  }
}

function toStatusT(x) {
  if (typeof x !== "number") {
    return {
            NAME: "EXPIRING",
            VAL: x._0
          };
  }
  switch (x) {
    case /* Active */0 :
        return "ACTIVE";
    case /* Withdrawn */1 :
        return "WITHDRAWN";
    case /* Rented */2 :
        return "RENTED";
    case /* Expired */3 :
        return "EXPIRED";
    case /* Removed */4 :
        return "REMOVED";
    
  }
}

var ListingStatus = {
  make: make,
  toStatusT: toStatusT
};

function isRemoved(v) {
  var match = v.status;
  if (typeof match === "number") {
    return match >= 4;
  } else {
    return false;
  }
}

function decode$3(obj) {
  var partial_arg = GraphQLConverter.Helpers.someOk(obj.expiryInfo, "expiryInfo was None");
  var partial_arg$1 = GraphQLConverter.Helpers.ok(GraphQLConverter.Helpers.decodeOption(GraphQLConverter.Helpers.parseUTCDateFromFloat, obj.rentalStatusChangeAt));
  var partial_arg$2 = GraphQLConverter.Helpers.ok(GraphQLConverter.Helpers.decodeRequired("updatedAt was None", GraphQLConverter.Helpers.parseUTCDateFromFloat, obj.updatedAt));
  var partial_arg$3 = GraphQLConverter.Helpers.ok(GraphQLConverter.Helpers.decodeRequired("createdAt was None", GraphQLConverter.Helpers.parseUTCDateFromFloat, obj.createdAt));
  var partial_arg$4 = GraphQLConverter.Helpers.some(obj.rentalNeedStatus)("status was None");
  var partial_arg$5 = function (param) {
    return GraphQLConverter.Helpers.flatMap((function (param) {
                  return GraphQLConverter.Helpers.source(obj, param);
                }), partial_arg$4, param);
  };
  var partial_arg$6 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$5, partial_arg$3, param);
  };
  var partial_arg$7 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$6, partial_arg$2, param);
  };
  var partial_arg$8 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$7, partial_arg$1, param);
  };
  return GraphQLConverter.Helpers.run(function (status, createdAt, updatedAt, statusChangeAt, expiryInfo) {
                return {
                        createdAt: createdAt,
                        updatedAt: updatedAt,
                        status: make(status, expiryInfo),
                        statusChange: statusChangeAt !== undefined ? /* StatusChange */({
                              _0: {
                                changeAt: Caml_option.valFromOption(statusChangeAt),
                                comment: obj.statusChangeComment
                              }
                            }) : /* NoChange */0,
                        expiryInfo: expiryInfo
                      };
              })(function (param) {
              return GraphQLConverter.Helpers.flatMap(partial_arg$8, partial_arg, param);
            });
}

var ppx_printed_query$3 = "fragment rentalNeedStatus on RentalNeed   {\nrentalNeedStatus: status  \ncreatedAt  \nupdatedAt  \nstatusChangeComment  \nrentalStatusChangeAt: statusChangeAt  \nexpiryInfo  {\n..." + ExpiryInfo.Fragment.name + "   \n}\n\n}\n" + ExpiryInfo.Fragment.query;

function parse$3(value) {
  var value$1 = Js_json.decodeObject(value);
  var tmp;
  if (value$1 !== undefined) {
    var value$2 = Caml_option.valFromOption(value$1);
    var value$3 = Js_dict.get(value$2, "rentalNeedStatus");
    var field_rentalNeedStatus;
    if (value$3 !== undefined) {
      var value$4 = Caml_option.valFromOption(value$3);
      if (value$4 == null) {
        field_rentalNeedStatus = undefined;
      } else {
        var tmp$1;
        switch (value$4) {
          case "ACTIVE" :
              tmp$1 = "ACTIVE";
              break;
          case "EXPIRED" :
              tmp$1 = "EXPIRED";
              break;
          case "RENTED" :
              tmp$1 = "RENTED";
              break;
          case "WITHDRAWN" :
              tmp$1 = "WITHDRAWN";
              break;
          default:
            tmp$1 = "REMOVED";
        }
        field_rentalNeedStatus = tmp$1;
      }
    } else {
      field_rentalNeedStatus = undefined;
    }
    var value$5 = Js_dict.get(value$2, "createdAt");
    var field_createdAt;
    if (value$5 !== undefined) {
      var value$6 = Caml_option.valFromOption(value$5);
      field_createdAt = (value$6 == null) ? undefined : Caml_option.some(value$6);
    } else {
      field_createdAt = undefined;
    }
    var value$7 = Js_dict.get(value$2, "updatedAt");
    var field_updatedAt;
    if (value$7 !== undefined) {
      var value$8 = Caml_option.valFromOption(value$7);
      field_updatedAt = (value$8 == null) ? undefined : Caml_option.some(value$8);
    } else {
      field_updatedAt = undefined;
    }
    var value$9 = Js_dict.get(value$2, "statusChangeComment");
    var field_statusChangeComment;
    if (value$9 !== undefined) {
      var value$10 = Caml_option.valFromOption(value$9);
      field_statusChangeComment = (value$10 == null) ? undefined : value$10;
    } else {
      field_statusChangeComment = undefined;
    }
    var value$11 = Js_dict.get(value$2, "rentalStatusChangeAt");
    var field_rentalStatusChangeAt;
    if (value$11 !== undefined) {
      var value$12 = Caml_option.valFromOption(value$11);
      field_rentalStatusChangeAt = (value$12 == null) ? undefined : Caml_option.some(value$12);
    } else {
      field_rentalStatusChangeAt = undefined;
    }
    var value$13 = Js_dict.get(value$2, "expiryInfo");
    var field_expiryInfo;
    if (value$13 !== undefined) {
      var value$14 = Caml_option.valFromOption(value$13);
      field_expiryInfo = (value$14 == null) ? undefined : ExpiryInfo.Fragment.parse(value$14);
    } else {
      field_expiryInfo = undefined;
    }
    tmp = {
      createdAt: field_createdAt,
      updatedAt: field_updatedAt,
      expiryInfo: field_expiryInfo,
      rentalStatusChangeAt: field_rentalStatusChangeAt,
      rentalNeedStatus: field_rentalNeedStatus,
      statusChangeComment: field_statusChangeComment
    };
  } else {
    tmp = Js_exn.raiseError("Unexpected GraphQL query response");
  }
  return decode$3(tmp);
}

var name$3 = "rentalNeedStatus";

function ret_type$3(f) {
  return {};
}

var MT_Ret$3 = {};

var RentalNeedStatus = {
  ppx_printed_query: ppx_printed_query$3,
  query: ppx_printed_query$3,
  parse: parse$3,
  name: name$3,
  ret_type: ret_type$3,
  MT_Ret: MT_Ret$3
};

var Status = {
  ListingStatus: ListingStatus,
  isRemoved: isRemoved,
  decode: decode$3,
  RentalNeedStatus: RentalNeedStatus,
  Fragment: undefined
};

function decode$4(raw) {
  var partial_arg = GraphQLConverter.Helpers.some(raw.areas)("areas was None");
  return GraphQLConverter.Helpers.run(function (areas) {
                return areas;
              })(function (param) {
              return GraphQLConverter.Helpers.flatMap((function (param) {
                            return GraphQLConverter.Helpers.source(raw, param);
                          }), partial_arg, param);
            });
}

var ppx_printed_query$4 = "fragment RentalNeedAreas on RentalNeed   {\nareas  {\n..." + AreaSummary.AreaSummary.name + "   \n}\n\n}\n" + AreaSummary.AreaSummary.query;

function parse$4(value) {
  var value$1 = Js_json.decodeObject(value);
  var tmp;
  if (value$1 !== undefined) {
    var value$2 = Js_dict.get(Caml_option.valFromOption(value$1), "areas");
    var field_areas;
    if (value$2 !== undefined) {
      var value$3 = Caml_option.valFromOption(value$2);
      field_areas = (value$3 == null) ? undefined : Js_array.map((function (value) {
                return AreaSummary.AreaSummary.parse(value);
              }), value$3);
    } else {
      field_areas = undefined;
    }
    tmp = {
      areas: field_areas
    };
  } else {
    tmp = Js_exn.raiseError("Unexpected GraphQL query response");
  }
  return decode$4(tmp);
}

function ret_type$4(f) {
  return {};
}

var MT_Ret$4 = {};

var RentalNeedAreas = {
  ppx_printed_query: ppx_printed_query$4,
  query: ppx_printed_query$4,
  parse: parse$4,
  name: "RentalNeedAreas",
  ret_type: ret_type$4,
  MT_Ret: MT_Ret$4
};

var Areas = {
  decode: decode$4,
  RentalNeedAreas: RentalNeedAreas,
  Fragment: undefined
};

function decode$5(obj) {
  var primaryContact = Belt_Option.flatMap(Belt_Option.flatMap(obj.client, (function (client) {
              return client.primaryContact;
            })), (function (contact) {
          return Types__Clients__Contact.name_of_contact(contact.firstName, contact.lastName);
        }));
  return Belt_Option.getWithDefault(primaryContact, "Buyer");
}

var ppx_printed_query$5 = "fragment RenterName on RentalNeed   {\nid  \nclient  {\nid  \nprimaryContact  {\nid  \nfirstName  \nlastName  \n}\n\n}\n\n}\n";

function parse$5(value) {
  var value$1 = value["client"];
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1["primaryContact"];
    var tmp$1;
    if (value$2 == null) {
      tmp$1 = undefined;
    } else {
      var value$3 = value$2["firstName"];
      var value$4 = value$2["lastName"];
      tmp$1 = {
        id: value$2["id"],
        firstName: !(value$3 == null) ? value$3 : undefined,
        lastName: !(value$4 == null) ? value$4 : undefined
      };
    }
    tmp = {
      id: value$1["id"],
      primaryContact: tmp$1
    };
  }
  return decode$5({
              id: value["id"],
              client: tmp
            });
}

function ret_type$5(f) {
  return {};
}

var MT_Ret$5 = {};

var RenterName = {
  ppx_printed_query: ppx_printed_query$5,
  query: ppx_printed_query$5,
  parse: parse$5,
  name: "RenterName",
  ret_type: ret_type$5,
  MT_Ret: MT_Ret$5
};

var RenterName$1 = {
  decode: decode$5,
  RenterName: RenterName,
  Fragment: undefined
};

function make$1(id, priceRange, areas, headline, propertyTypes, lease, minBeds, remarks, status) {
  return {
          id: id,
          priceRange: priceRange,
          areas: areas,
          headline: headline,
          propertyTypes: propertyTypes,
          lease: lease,
          minBeds: minBeds,
          remarks: remarks,
          status: status
        };
}

function decode$6(obj) {
  var func = GraphQLConverter.Converter.runConverter;
  var partial_arg = GraphQLConverter.Converter.some((function (obj) {
          return obj.remarks;
        }), "missing remarks");
  var partial_arg$1 = GraphQLConverter.Converter.$$const(function (obj) {
        return obj.minBeds;
      });
  var partial_arg$2 = GraphQLConverter.Converter.some((function (obj) {
          return obj.headline;
        }), "missing headline");
  var partial_arg$3 = GraphQLConverter.Converter.some((function (obj) {
          return obj.areas;
        }), "missing areas");
  var partial_arg$4 = GraphQLConverter.Converter.$$const(function (obj) {
        return obj.id;
      });
  var partial_arg$5 = function (param) {
    return GraphQLConverter.Helpers.flatMap((function (param) {
                  return GraphQLConverter.Converter.source(obj, param);
                }), partial_arg$4, param);
  };
  var partial_arg$6 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$5, (function (param) {
                  return GraphQLConverter.Converter.ok((function (obj) {
                                return obj.priceRange;
                              }), param);
                }), param);
  };
  var partial_arg$7 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$6, partial_arg$3, param);
  };
  var partial_arg$8 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$7, partial_arg$2, param);
  };
  var partial_arg$9 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$8, (function (param) {
                  return GraphQLConverter.Converter.ok((function (obj) {
                                return obj.rentalNeedPropertyTypes;
                              }), param);
                }), param);
  };
  var partial_arg$10 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$9, (function (param) {
                  return GraphQLConverter.Converter.ok((function (obj) {
                                return obj.lease;
                              }), param);
                }), param);
  };
  var partial_arg$11 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$10, partial_arg$1, param);
  };
  var partial_arg$12 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$11, partial_arg, param);
  };
  return Curry._2(func, (function (param) {
                return GraphQLConverter.Helpers.flatMap(partial_arg$12, (function (param) {
                              return GraphQLConverter.Converter.ok((function (obj) {
                                            return obj.rentalStatus;
                                          }), param);
                            }), param);
              }), make$1);
}

var ppx_printed_query$6 = "fragment BasicRentalNeed__RentalNeed on RentalNeed   {\nid  \nheadline  \nareas  {\n..." + AreaSummary.AreaSummary.name + "   \n}\n\n..." + name$3 + "   \n..." + name + "   \n..." + name$1 + "   \n..." + name$2 + "   \nminBeds  \nremarks  \n}\n" + AreaSummary.AreaSummary.query + ppx_printed_query$2 + ppx_printed_query + ppx_printed_query$1 + ppx_printed_query$3;

function parse$6(value) {
  var value$1 = value["headline"];
  var value$2 = value["areas"];
  var value$3 = value["minBeds"];
  var value$4 = value["remarks"];
  return decode$6({
              id: value["id"],
              headline: !(value$1 == null) ? value$1 : undefined,
              areas: !(value$2 == null) ? Js_array.map((function (value) {
                        return AreaSummary.AreaSummary.parse(value);
                      }), value$2) : undefined,
              rentalStatus: parse$3(value),
              priceRange: parse(value),
              rentalNeedPropertyTypes: parse$1(value),
              lease: parse$2(value),
              minBeds: !(value$3 == null) ? value$3 : undefined,
              remarks: !(value$4 == null) ? value$4 : undefined
            });
}

function ret_type$6(f) {
  return {};
}

var MT_Ret$6 = {};

var BasicRentalNeed__RentalNeed = {
  ppx_printed_query: ppx_printed_query$6,
  query: ppx_printed_query$6,
  parse: parse$6,
  name: "BasicRentalNeed__RentalNeed",
  ret_type: ret_type$6,
  MT_Ret: MT_Ret$6
};

var Basic = {
  make: make$1,
  decode: decode$6,
  BasicRentalNeed__RentalNeed: BasicRentalNeed__RentalNeed,
  Fragment: undefined
};

exports.defaultToFalse = defaultToFalse;
exports.defaultToTrue = defaultToTrue;
exports.decodeOptionalUTCDate = decodeOptionalUTCDate;
exports.decodeOptionalCalendarDate = decodeOptionalCalendarDate;
exports.PriceRange = PriceRange;
exports.PropertyTypes = PropertyTypes;
exports.Lease = Lease;
exports.Status = Status;
exports.Areas = Areas;
exports.RenterName = RenterName$1;
exports.Basic = Basic;
/* ExpiryInfo Not a pure module */
